export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true" focusable="false">
    <path d="M3 34 L15 12 L21 22 L26 15 L37 34 Z" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
    <path d="M20 33c-3.6 0-5.6-2.6-5.6-5.4 0-3.4 3-5 3.6-8.6 2.4 1.6 3 3.6 2.8 5.4 1-.6 1.6-1.6 1.8-2.8 1.8 1.6 3 3.6 3 6 0 3-2.4 5.4-5.6 5.4z" fill="#a0764f" />
  </svg>
);
